import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=b2c52b8a&scoped=true&"
import script from "./Guest.vue?vue&type=script&lang=js&"
export * from "./Guest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c52b8a",
  null
  
)

export default component.exports